function ngDisabled() {
  return {
    restrict: 'A',
    require: '?^^ogFormfield',
    link: function($scope, $element, $attrs, ogFormfield) {
      $scope.$watch(() => $scope.$eval($attrs.ngDisabled), (val) => {
        if (ogFormfield) {
          ogFormfield.isDisabled = val;
        }
      });
    }
  };
}

ngDisabled.$inject = [];

module.exports = ngDisabled;
